module.exports = __webpack_public_path__ + "static/masonry-image-3-59d3b6728f11bbd8ea505b418cde5a15.jpg";